import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminMomentsBusinesses = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/moments/businesses/show.vue')
    createVueApp(ShowPage, { props })
  }
}
